var React = require('react');

function XIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"-4.9","y":"16.2","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 19.0914 -7.8744)","fill":"currentColor","width":"47.8","height":"5.7","key":0}),React.createElement("rect",{"x":"-4.9","y":"16.2","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 46.0336 19.1487)","fill":"currentColor","width":"47.8","height":"5.7","key":1})]));
}

XIcon.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 38.1 38.1","style":{"enableBackground":"new 0 0 38.1 38.1"},"xmlSpace":"preserve"};

module.exports = XIcon;

XIcon.default = XIcon;
